import React from "react";
import Head from "./Head/Head";

const about = () => {
  return (
    <>
      <Head />
      <div style={{padding:'10rem'}}>about</div>
    </>
  );
};

export default about;
